import {
  createReqConsts,
  createActions,
  createReqWatcher,
  createReqReducer,
} from '../../../utils/redux';

const makeUsernameAvailabilityReqConfig = () => ({
  endpoint: 'profiles',
  type: 'get',
  slug: [
    'username_availability',
    {
      type: 'payload.query',
      queryParameter: 'username',
      selector: 'username',
    },
  ],
});

const requestOptions = makeUsernameAvailabilityReqConfig();

export const consts = createReqConsts('auth', 'username-availability');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, requestOptions, true);

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/auth/signup/username-availability-req.js